import { useMemo } from 'react';
import PortalIdParser from 'PortalIdParser';
import { getPropertyChangedEventDefinition, getPropertyChangedEventProperty } from 'flow-doctor-lib/utils/propertyChangedEventDef';
import usePropertiesWithOptions from 'flow-doctor-lib/hooks/usePropertiesWithOptions';
/**
 * "Property event changed" events have a different structure than all other Unified Events we use.
 * They consist of a string "hs_name" containing the raw name of the property, along with a string "hs_value"
 * denoting the property's value. On the BE this is always a string, but we need to override that here in order
 * to properly display the property's value in the UI.
 */
const usePropertyEventChangedPropertiesAndDefinitions = ({
  propertyDefinitions,
  properties,
  associatedObjectTypeId
}) => {
  const propertyName = properties.hs_name.value;
  const propertyValue = properties.hs_value.value;
  const {
    propertyWrapper: associatedObjectPropertyDefinition
    // loading: propertyMapLoading,
    // error: propertyMapError,
  } = usePropertiesWithOptions({
    portalId: PortalIdParser.get(),
    propertyName,
    objectTypeId: associatedObjectTypeId,
    rawOptions: [propertyValue]
  });
  return useMemo(() => {
    if (!associatedObjectPropertyDefinition) {
      return {
        mappedPropertyDefinitions: propertyDefinitions,
        mappedProperties: properties
      };
    }
    const mappedPropertyDefinitions = Object.entries(propertyDefinitions).reduce((acc, [propName, propertyDef]) => Object.assign({}, acc, {
      [propName]: getPropertyChangedEventDefinition(propertyDef, associatedObjectPropertyDefinition)
    }), {});
    const mappedProperties = Object.entries(properties).reduce((acc, [propName, property]) => Object.assign({}, acc, {
      [propName]: getPropertyChangedEventProperty(propName, property, associatedObjectPropertyDefinition)
    }), {});
    return {
      mappedPropertyDefinitions,
      mappedProperties
    };
  }, [propertyDefinitions, properties, associatedObjectPropertyDefinition]);
};
export default usePropertyEventChangedPropertiesAndDefinitions;